import moment from 'moment'
import Vue from 'vue'
import VueCookies from 'vue-cookies'

import Vidle from 'v-idle'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'
import Hotjar from 'vue-hotjar'
import App from './App.vue'
import createDynamicTheme from './common/theme'
import eventBus from './event-bus.js'
import eventTypes from './eventTypes'
import i18n from './i18n'
import vuetify from './plugins/vuetify'
import createRouter from './router'
import server from './services/api/server'
import users from './services/api/users'
import createAuth from './services/auth/auth.js'
import store from './store'
import CommonError from './views/CommonError'
import RsspError from './views/RsspError'

Vue.config.productionTip = false
// todo temporary console cleanup
// Vue.config.silent = true
Vue.config.devtools = 'source-map'
Vue.use(VueCookies)
Vue.use(Vidle)
Vue.use(VueCookieAcceptDecline)

Vue.mixin({
  methods: {
    convertDate(value) {
      if (value == null) {
        return ' - '
      }

      return moment(value).local().format()
    },
    convertDateEmpty(value) {
      if (value == null) {
        return ''
      }

      return moment(value).local().format()
    },
    setLanguage(locale, callrefresh = true) {
      // console.log('Before', this.$vuetify.lang)
      this.$i18n.locale = locale // Set the new locale
      this.$vuetify.lang.current = locale // update Vuetify's language setting
      // console.log('After', this.$vuetify.lang)
      if (callrefresh) {
        window.location.reload() // dirty hack to refresh the navigation menu localisation too
      }
    },
    getErrorMessage(error) {
      let errorMsg = this.$t('toastMessage.errorWhileRetrievingData')
      if (error.response !== undefined) {
        console.error('error.response', error.response)
      } else {
        console.error('error', error)
        // console.log('error.code', error.code)
      }
      if ((error.response !== undefined) && (error.response.data.error !== undefined)) {
        // const errorcode = error.response.data.code.toUpperCase()
        const errorcode = error.response.data.error.toUpperCase()
        switch (errorcode) {
          case RsspError.INCORRECT_KEYPASSWORD_OR_PUK:
            errorMsg = this.$t('backendErrors.INCORRECT_KEYPASSWORD_OR_PUK')
            break
          case RsspError.CREDENTIAL_NOT_ACTIVATED:
            errorMsg = this.$t('backendErrors.CREDENTIAL_NOT_ACTIVATED')
            break
          case RsspError.KEY_BLOCKED:
            errorMsg = this.$t('backendErrors.KEY_BLOCKED')
            break
          case RsspError.USER_SUSPENDED:
            this.$router.push('/permissionDenied')
            break
          case CommonError.ALREADY_EXISTS:
            errorMsg = this.$t('toastMessage.alreadyExist', { 0: error.response.data.error_description.split(' ')[0] })
            // errorMsg = this.$t('toastMessage.alreadyExist', { 0: error.response.data.error.split(' ')[0] })
            break
          case CommonError.STILL_REFERENCED:
            // eslint-disable-next-line no-case-declarations
            // const splittedErrorDescription = error.response.data.error.split(' ')
            // eslint-disable-next-line no-case-declarations
            const splittedErrorDescription = error.response.data.error_description.split(' ')
            errorMsg = this.$t('toastMessage.stillReferenced', { 0: splittedErrorDescription[0], 1: splittedErrorDescription[5] })
            break
          case CommonError.GENERAL:
          case CommonError.BAD_REQUEST:
          case CommonError.BAD_REQUEST2:
          case CommonError.INVALID_REQUEST:
          case CommonError.DEFAULT_INVALID_REQUEST:
          case CommonError.VALIDATION_FAILED:
          case CommonError.INVALID_JSON:
          case CommonError.FORBIDDEN:
          case CommonError.NOT_FOUND:
            // console.log('General error')
            errorMsg = error.response.data.error_description !== undefined ? this.$t('backendErrors.CLIENT_ERROR', { message: error.response.data.error_description }) : this.$t('backendErrors.CLIENT_ERROR_NO_MSG') +
              ' ' + this.$t('backendErrors.ADDITIONAL_DETAILS', { datetime: new Date().toUTCString(), code: errorcode })
            break
          default:
            errorMsg = this.$t('backendErrors.SERVER_ERROR') + ' ' + this.$t('backendErrors.ADDITIONAL_DETAILS', { datetime: new Date().toUTCString(), code: errorcode })
        }
      } else {
        errorMsg = this.getNotHandledErrorMessage(error)
      }
      return errorMsg
    },
    getNotHandledErrorMessage(error) {
      // console.log(this)
      if (error.response !== undefined) {
        if (error.response.status === 500) {
          // return this.$t('backendErrors.SERVER_ERROR') + this.$t('backendErrors.ADDITIONAL_DETAILS', { datetime: new Date().toUTCString(), code: error.response.status })
          return this.$t('backendErrors.SERVER_ERROR') + ' ' + this.$t('backendErrors.ADDITIONAL_DETAILS', { datetime: new Date().toUTCString(), code: error.response.status })
        } else {
          return this.$t('backendErrors.SERVER_ERROR') + ' ' + this.$t('backendErrors.ADDITIONAL_DETAILS', { datetime: new Date().toUTCString(), code: error.response.status })
        }
      } else {
        // timeout error
        if (error.code === 'ECONNABORTED') {
          return this.$t('errors.timeOut') + ' ' + this.$t('errors.additionalDetails', { datetime: new Date().toUTCString(), msg: error.message })
        } else {
          return this.$t('backendErrors.SERVER_ERROR') + ' ' + this.$t('backendErrors.ADDITIONAL_DETAILS', { datetime: new Date().toUTCString(), code: error.code })
        }
      }
    },

    setThemeImpl(theme) {
      // close menu
      // this.menu = false
      console.debug('setThemeImpl', theme)
      const name = theme.name
      // const dark = theme.dark
      // const light = theme.light
      this.headerLogo = theme.headerLogo
      const light = theme.colors
      // set themes
      Object.keys(light).forEach(i => {
        this.$vuetify.theme.themes.light[i] = light[i]
      })
      // also save theme name to disable selection
      this.$vuetify.theme.themes.name = name
    }
  }
})

moment.defaultFormat = 'YYYY.MM.DD, HH:mm:ss'
let app
let initLocaleCalled = false

async function main() {
  const auth = await createAuth()
  Vue.prototype.$auth = auth

  const remoteConfig = await server.getRemoteConfig()
  store.commit('setRemoteConfig', remoteConfig)

  const HOTJAR_SITEID = store.state.remoteConfig.hotjarSiteId
  if (HOTJAR_SITEID && (HOTJAR_SITEID.length > 0)) {
    Vue.use(Hotjar, {
      id: HOTJAR_SITEID // Hotjar Site ID
    })
  }

  if ((store.state.remoteConfig.theme) && (store.state.remoteConfig.theme.colors)) {
    const dynamicTheme = createDynamicTheme(store.state.remoteConfig.theme)
    store.commit('setCurrentTheme', dynamicTheme)
  }

  const authUser = await auth.getUser()

  if (authUser) {
    let currentUser = { roles: [''] }
    // console.debug('main.js authUser', authUser)
    try {
      currentUser = await users.joinUser()
      i18n.locale = currentUser.locale ? currentUser.locale.toLowerCase() : 'en' // Set the new locale
    } catch (error) {
      // console.error(error)
      store.commit('setCurrentUser', null)
    }
    store.commit('setCurrentUser', currentUser)
  } else {
  }

  auth.addUserLoaded(initLocale)
  auth.addUserUnloaded(userUnloaded)

  const router = createRouter(auth)
  if (store.state.currentUser?.status === 'SUSPENDED') {
    router.push({ name: 'PermissionDenied' })
  }

  router.onReady(initEventSource)

  app = new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

main()

let sse

async function initLocale() {
  if (initLocaleCalled) {
    return
  }
  initLocaleCalled = true

  const authUser = await Vue.prototype.$auth.getUser()
  if (!authUser) return

  try {
    if (!authUser.profile.locale) {
      const user = await users.joinUser()
      if (user) {
        authUser.profile.locale = user.locale
        store.commit('setCurrentUser', user)
      }
    }

    if (!store.state.currentUser) {
      const user = await users.joinUser()
      store.commit('setCurrentUser', user)
    }

    const currentUser = store.state.currentUser
    const resolvedLocale = (currentUser?.locale || authUser.profile.locale || 'en').toLowerCase()

    if (i18n) i18n.locale = resolvedLocale

    if (app) {
      app.setLanguage(resolvedLocale, false)
    } else {
      vuetify.framework.lang.current = resolvedLocale
    }
  } catch (e) {
    console.error('initLocale error', e)
  }
}

async function userUnloaded() {
  // console.log('rssp auth, user unloaded, removing from store')
  store.commit('removeCurrentUser')
}

async function initEventSource() {
  const token = await Vue.prototype.$auth.getIdToken()

  const eventSourceURL = store.state.remoteConfig.rsspApiUrl + '/rssp/v1/events'

  try {
    // eslint-disable-next-line
    sse = new EventSourcePolyfill(eventSourceURL, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  } catch (e) {
    console.error(e)
  }

  sse.onopen = (e) => {
    // console.log('CONNECTION open')
    eventBus.$emit(eventTypes.CONNECTION_ESTABLISHED)
  }

  sse.onerror = (error) => {
    // console.log('CONNECTION_LOST', error)
    eventBus.$emit(eventTypes.CONNECTION_LOST, error)
  }

  sse.addEventListener(eventTypes.HEARTBEAT, (event) => {
    eventBus.$emit(eventTypes.HEARTBEAT)
  })

  sse.addEventListener(eventTypes.LOGOUT, (event) => {
    // console.log('SSE LOGOUT', event)
    eventBus.$emit(eventTypes.LOGOUT, JSON.parse(event.data))
  })
}
